import { produce } from "../../../../../../../../../../../libs/immer";
import { formatValue as formatAccountNumber, unformatValue } from "../utils";
import { validatePhoneUseCase } from "../validatePhone.case";
import { templateParser } from "../../../../../../../../../../../utils/strings";
import { kopeikiToRubles } from "../../SumInput/utils";
import { INPUT_LENGTH } from "../../../../../../../../../../../constants";
export var getMapStateToPhoneInputProps = function getMapStateToPhoneInputProps(_ref) {
  var getContent = _ref.getContent,
    getIsBeelineError = _ref.getIsBeelineError,
    Component = _ref.Component;
  return function (getState, setState) {
    var state = getState();
    var content = getContent();
    var placeholder = templateParser(content.phoneInput.placeholder, {
      min: kopeikiToRubles(content.paymentParams.amount.min),
      max: kopeikiToRubles(content.paymentParams.amount.max)
    });
    return {
      Component: Component,
      label: content.phoneInput.label,
      onBlur: function onBlur() {
        return validatePhoneUseCase({
          getContent: getContent,
          getIsBeelineError: getIsBeelineError
        })(state.phoneInput.value, setState).catch(console.error);
      },
      onChange: function onChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var _value = unformatValue(value);
        setState(produce(function (draft) {
          draft.phoneInput.value = _value;
        }));
        if (_value.length === INPUT_LENGTH) {
          validatePhoneUseCase({
            getContent: getContent,
            getIsBeelineError: getIsBeelineError
          })(_value, setState).catch(console.error);
        }
      },
      onClick: function onClick() {},
      isLoading: state.isLoading,
      placeholder: placeholder,
      value: formatAccountNumber(state.phoneInput.value),
      disabled: state.phoneInput.isDisabled,
      error: state.phoneInput.errorMessage
    };
  };
};